import * as tslib_1 from "tslib";
import "babel-polyfill";
import "./config/axios";
import env from "@/config/env";
import * as platform from "@cloudpivot/platform";
import { formApi } from "@cloudpivot/api";
import { startup } from "./startup";
import initFormComponent from "@cloudpivot/form/registerComponent";
import common from "@cloudpivot/common/mobile";
import Vues from "vue";
/**
 * 解析当前地址栏 query 参数
 * 这里只处理 portal 入口层需要的简单参数结构，避免飞书浏览器打开时过早进入平台 SDK 逻辑
 */
function parseEntryQuery() {
    const query = {};
    const search = window.location.search.replace(/^\?/, "");
    if (!search) {
        return query;
    }
    search.split("&").forEach((item) => {
        if (!item) {
            return;
        }
        const index = item.indexOf("=");
        const key = index > -1 ? item.slice(0, index) : item;
        const value = index > -1 ? item.slice(index + 1) : "";
        query[key] = decodeURIComponent(value);
    });
    return query;
}
/**
 * 判断当前是否为飞书工作台“浏览器打开”场景
 * 该场景地址会携带 lk_jump_to_browser=true，但浏览器环境本身没有飞书 H5 SDK 能力
 */
function isFeishuBrowserOpen(query) {
    const platformType = `${query.platform || ""}`.toLowerCase();
    const isFeishuPlatform = platformType === "feishu" || platformType === "feishuwork";
    const isBrowserOpen = `${query.lk_jump_to_browser || ""}` === "true";
    const isFeishuContainer = /Feishu|Lark/i.test(navigator.userAgent);
    return isFeishuPlatform && isBrowserOpen && !isFeishuContainer;
}
/**
 * 判断本地 token 是否仍然有效
 * expireTime 可能是秒级时间戳，也可能是毫秒级时间戳，这里统一兼容
 */
function hasValidToken() {
    const token = localStorage.getItem("token");
    const expireTime = localStorage.getItem("expireTime");
    if (!token) {
        return false;
    }
    if (!expireTime) {
        return true;
    }
    let expireTimestamp = parseInt(expireTime, 10);
    if (Number.isNaN(expireTimestamp)) {
        return true;
    }
    if (`${expireTimestamp}`.length === 10) {
        expireTimestamp *= 1000;
    }
    return Date.now() < expireTimestamp;
}
/**
 * 清理飞书浏览器打开场景的专用参数
 * 清理后重新进入项目时，不再误判为飞书容器内 H5 登录
 */
function getFeishuBrowserTargetUrl() {
    const query = parseEntryQuery();
    const cleanQuery = Object.assign({}, query);
    delete cleanQuery.platform;
    delete cleanQuery.lk_jump_to_browser;
    delete cleanQuery.from;
    delete cleanQuery.timestamp;
    const queryString = Object.keys(cleanQuery)
        .filter((key) => cleanQuery[key] !== undefined && cleanQuery[key] !== null && cleanQuery[key] !== "")
        .map((key) => `${key}=${encodeURIComponent(cleanQuery[key])}`)
        .join("&");
    const baseUrl = `${window.location.origin}${window.location.pathname}`;
    return `${baseUrl}${queryString ? `?${queryString}` : ""}${window.location.hash || ""}`;
}
/**
 * 处理飞书工作台“浏览器打开”逻辑
 * 1. 已有有效 token：直接去掉飞书专用参数，按普通浏览器页面访问
 * 2. 无 token 或 token 过期：改走飞书网页 OAuth，回调到 /login 后复用现有 /login/feishu 登录逻辑
 */
function handleFeishuBrowserOpen() {
    const query = parseEntryQuery();
    if (!isFeishuBrowserOpen(query)) {
        return false;
    }
    const targetUrl = getFeishuBrowserTargetUrl();
    const corpId = `${query.corpId || ""}`;
    if (corpId) {
        localStorage.setItem("corpId", corpId);
    }
    if (hasValidToken()) {
        window.location.replace(targetUrl);
        return true;
    }
    const appId = `${query.appId || window.config.appId || ""}`;
    if (!corpId || !appId) {
        return false;
    }
    localStorage.setItem("copy_link_url_path", targetUrl);
    const redirectUri = encodeURIComponent(`${window.location.origin}/login`);
    const state = encodeURIComponent(corpId);
    window.location.href = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${appId}&redirect_uri=${redirectUri}&response_type=code&state=${state}`;
    return true;
}
initFormComponent();
if (!handleFeishuBrowserOpen()) {
    platform.start(env.client_id, env.scope).then((result) => {
        if (!result)
            return;
        const { query } = result;
        if (query.messageId && common.utils.Common.isPC) {
            openMessage(query.messageId);
        }
        else if (query.messageId && !common.utils.Common.isPC) {
            window.location.href = `${env.portalHost}/mobile/?messageId=${query.messageId}`;
        }
        else {
            startup(query);
            // import(/* webpackChunkName: "startup" */'./startup').then( obj => {
            //   obj.startup(query);
            // });
        }
    });
}
Vues.prototype.getPopupContainer = (triggerNode) => {
    console.log(triggerNode, 'triggerNodetriggerNode', triggerNode.parentNode);
    return triggerNode.parentNode.parentNode;
};
/**
 * 根据消息打开页面
 * @param messageId
 */
function openMessage(messageId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const $app = document.getElementById("app");
        if (!$app) {
            throw new Error(`can't find #app`);
        }
        const params = {
            messageId
        };
        const token = localStorage.getItem("token");
        if (token) {
            const res = yield formApi.getMessageFormUrl(params);
            if (res.errcode === 0 && res.data) {
                // 跳转到消息地址或者第三方浏览器直接打开地址
                const { bizObjectId, workItemId, workflowInstanceId, schemaCode, sheetCode, url } = res.data;
                // alert(`结果详情：bizobjectid:${bizObjectId},workitemid:${workItemId},workflowinstanceid:${workflowInstanceId}`);
                let theUrl = "";
                if (url) {
                    if (url.indexOf("?") > -1) {
                        theUrl = `${url}&access_token=${token}`;
                    }
                    else {
                        theUrl = `${url}?access_token=${token}`;
                    }
                }
                else {
                    theUrl = `${env.portalHost}/form/detail?`;
                    if (workflowInstanceId) {
                        theUrl += `workflowInstanceId=${workflowInstanceId}&workitemId=${workItemId ||
                            ""}&access_token=${token}`;
                    }
                    else {
                        theUrl += `objectId=${bizObjectId}&schemaCode=${schemaCode}&sheetCode=${sheetCode}&access_token=${token}`;
                    }
                }
                $app.innerText = "";
                $app.style.textAlign = "center";
                $app.style.paddingTop = "20px";
                $app.style.color = "#666";
                $app.style.fontSize = "18px";
                const $a = document.createElement("a");
                $a.style.textDecoration = "underline";
                $a.href = theUrl;
                $a.target = "_blank";
                $a.innerText = "浏览器打开应用";
                $app.appendChild($a);
                // window.location.href = theUrl;
                platform.service.openLink(theUrl);
            }
        }
        else {
            localStorage.setItem("isShowEmailResquest", `${env.portalHost}?messageId=${messageId}`);
            const theUrl = `${env.portalHost}/login`;
            window.location.href = theUrl;
        }
    });
}
